import {
  FETCH_TOP_FOLDERS, FETCH_USERS,
  FETCH_CONTENT, LOAD_CONTENT, LOAD_TOP_FOLDERS, LOAD_USERS
} from '../Actions/Content'
import { emptyContent } from './Overview'

const initialState = {
  topCommented: [],
  topCommentedLength: 0,
  topLiked: [],
  topLikedLength: 0,
  topFolders: [],
  topFoldersLength: 0,
  mostEngaged: [],
  mostEngagedLength: 0,
  topViewed: [],
  topViewedLength: 0,
  topFeed: [],
  topFeedLength: 0,
  topExplore: [],
  topExploreLength: 0,
  users: [],
  usersLength: 0
}

const loadingUser = {
  _id: 'none',
  name: 'Loading',
  registrationDate: 0,
  totalLogins: 0,
  latestActivity: 0,
  adminType: '',
  avgDurationInApp: 0,
  avgDurationInCMS: 0,
  contentAdded: 0,
  contentFoldersAdded: 0,
  lastLogin: 0,
  appProfiles: 0,
  groups: 0
}

/**
  * ContentReducer
  * @desc Content State handler for content data
  * @param {Object} state
  * @param {action} action
  * @return {Object} updated content state
*/
export default function ContentReducer (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }

  const allUsers = action.data && action.data.allUsers
    ? { users: action.data.allUsers.users, usersLength: action.data.allUsers.count }
    : { users: [], count: 0 }

  switch (action.type) {
    case FETCH_CONTENT:
      return Object.assign({}, state, { [action.destination]: [Object.assign({}, emptyContent, { title: 'Loading' })] })
    case LOAD_CONTENT:
      return Object.assign({}, state, { [action.destination]: action.data.getContentAnalytics.content, [action.destination + 'Length']: action.data.getContentAnalytics.count, accountDetails: action.data.getContentAnalytics.accountDetails || {} })
    case FETCH_TOP_FOLDERS:
      return Object.assign({}, state, { topFolders: [{ _id: '0', title: 'Loading', totalViews: 0 }] })
    case LOAD_TOP_FOLDERS:
      return Object.assign({}, state, { topFolders: action.data.getFolderAnalytics.folders, topFoldersLength: action.data.getFolderAnalytics.count })
    case FETCH_USERS:
      return Object.assign({}, state, { users: [loadingUser] })
    case LOAD_USERS:
      return Object.assign({}, state, allUsers)
    default:
      return state
  }
}
